import { BellOutlined, DownloadOutlined, EllipsisOutlined, FieldTimeOutlined, PlusCircleOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, ColorPicker, Input, Select, Tabs, TabsProps } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import Layout from '../../../Layout';
import * as campaignApi from '../../../api/campaign/campaignApi';
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock';
import { LIMIT_EXPORT_EXCEL, URL_CHANNEL } from '../../../env';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useThrottle from '../../../hook/useThrottle';
import useToast from '../../../hook/useToast';
import { DataChannel, StatusSendCampaign } from '../../../services/data';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { formatPrice, getWidthFromHeader, getUserPermissions, getWidthFromHeaderV2, getPermissionClass } from '../../../until';
import AutomatedCampaignDetailPopup from '../CampaignSendsNotificationsComponents/AutomatedCampaignDetailPopup';
import AutomatedCampaignPopup from '../CampaignSendsNotificationsComponents/AutomatedCampaignPopup';
import AutomatedCampaignTable from '../CampaignSendsNotificationsComponents/AutomatedCampaignTable';
import ManualCampaignPopup from '../CampaignSendsNotificationsComponents/ManualCampaignPopup';
import ManualCampaignTable, { DataTypeCampaignManual } from '../CampaignSendsNotificationsComponents/ManualCampaignTable';
import './CampaignSendsNotifications.scss';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import { PaginationProps } from 'antd/lib';
import ModalTarget from './Modal/ModalTarget';
import DrawerAddvance from '../../VehicleManagement/VehicleList/Component/Drawer/DrawerAddvance';
import { ColDef } from 'ag-grid-community';
export enum ETypeSendCampaign {
  MANUALCAMPAIGN = '0',
  AUTOMATEDCAMPAIGN = '1',
}

const LOCAL_STORAGE_KEY = 'campaignManualColumns'
const LOCAL_STORAGE_KEY_AUTO = 'campaignAutoColumns'
const SESSION_TAB_KEY = 'campaignSelectedTab'

const defaultColumnsShow = [
  'action', 'muc_tieu', 'ma_chien_dich', 'ten_chien_dich',
  'trang_thai', 'kenh_gui',
  'da_gui', 'thoi_gian_gui', 'da_chi_tieu', 'nguoi_tao',
  'ngay_tao',
]
const defaultColumnsShowAuto = [
  'action', 'muc_tieu', 'ma_chien_dich', 'ten_chien_dich',
  'trang_thai', 'kenh_gui',
  'da_gui', 'thoi_gian_gui', 'da_chi_tieu', 'nguoi_tao',
  'ngay_tao',
]


const baseColumnDefs: ColDef[] = [
  { headerName: 'Hành động', field: 'id', colId: 'action', width: 200, resizable: false, suppressMovable: true, lockPosition: 'left' as const },
  { headerName: 'Mục tiêu', field: 'muc_tieu', colId: 'muc_tieu', width: getWidthFromHeaderV2('Mục tiêu') },
  { headerName: 'Mã chiến dịch', field: 'ma_chien_dich', colId: 'ma_chien_dich', width: getWidthFromHeaderV2('Mã chiến dịch') },
  { headerName: 'Tên chiến dịch', field: 'ten_chien_dich', colId: 'ten_chien_dich', width: getWidthFromHeaderV2('Tên chiến dịch') },
  { headerName: 'Trạng thái', field: 'trang_thai', colId: 'trang_thai', width: getWidthFromHeaderV2('Trạng thái') },
  { headerName: 'Kênh gửi', field: 'kenh_gui', colId: 'kenh_gui', width: getWidthFromHeaderV2('Kênh gửi') },
  // { headerName: 'Khách hàng nhận', field: 'nhom_khach_hang_nhan', colId: 'nhom_khach_hang_nhan', width: getWidthFromHeaderV2('Khách hàng nhận') },
  { headerName: 'Đã gửi', field: 'da_gui', colId: 'da_gui', width: getWidthFromHeaderV2('Đã gửi') },
  { headerName: 'Thời gian gửi', field: 'thoi_gian_gui', colId: 'thoi_gian_gui', width: getWidthFromHeaderV2('Thời gian gửi') },
  { headerName: 'Đã chi tiêu', field: 'da_chi_tieu', colId: 'da_chi_tieu', width: getWidthFromHeaderV2('Đã chi tiêu') },
  { headerName: 'Người tạo', field: 'nguoi_tao', colId: 'nguoi_tao', width: getWidthFromHeaderV2('Người tạo') },
  { headerName: 'Ngày tạo', field: 'ngay_tao', colId: 'ngay_tao', width: getWidthFromHeaderV2('Ngày tạo') },
]


// TABs
const tabItems: TabsProps['items'] = [
  {
    label: 'Thủ công',
    key: ETypeSendCampaign.MANUALCAMPAIGN.toString(),
    icon: <BellOutlined />,
  },
  {
    label: 'Tự động',
    key: ETypeSendCampaign.AUTOMATEDCAMPAIGN.toString(),
    icon: <FieldTimeOutlined />,
  },
];



const CampaignSendsNotifications: React.FC = () => {

  useEffect(() => {
    document.title = 'THACO AUTO CRM';
    return () => {
      setDataFilter(undefined)

      setPagination({ current: 1, pageSize: 12, total: 0 })

      setListCampaignManual([])
    }

  }, [])


  const pushToast = useToast();
  const pushLoading = useLoading();

  const location = useLocation();
  const navigate = useNavigate()

  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, download } = getUserPermissions(permissionSlice, location.pathname)

  const [isModalDelete, setIsModalDelete] = useState(false)
  const [isModalTarget, setIsModalTarget] = useState(false)
  const [loadingTable, setLoadingTable] = useState(false)

  const [isOpenAddvance, setIsOpenAddvance] = useState(false)


  const [columnDefs, setColumnDefs] = useState<ColDef[]>(baseColumnDefs)
  const [columnDefsAuto, setColumnDefsAuto] = useState<ColDef[]>(baseColumnDefs)


  const [selectedTab, setSelectedTab] = useState(sessionStorage.getItem(SESSION_TAB_KEY) || ETypeSendCampaign.MANUALCAMPAIGN.toString());

  const [dataFilter, setDataFilter] = useState<number>()
  const [searchKeyword, setSearchKeyword] = useState<string>('')

  const [pagination, setPagination] = useState({ current: 1, pageSize: 12, total: 0 });
  const [paginationAuto, setPaginationAuto] = useState({ current: 1, pageSize: 12, total: 0 });

  const [infoCampaign, setInfoCampaign] = useState<campaignApi.IICampaignDetail>()
  const [id, setId] = useState<number>();

  const [listCampaignManual, setListCampaignManual] = useState<DataTypeCampaignManual[]>([])
  const [listCampaignAuto, setListCampaignAuto] = useState<DataTypeCampaignManual[]>([])

  // const [manualCampPopupShow, setManualCampPopupShow] = useState(false)
  const [autoCampPopupShow, setAutoCampPopupShow] = useState(false)
  const [autoCampDetailPopupShow, setAutoCampDetailPopupShow] = useState(false)


  const columnDefsWithVisibility = useMemo(() => {
    const saved: string[] = localStorage.getItem(LOCAL_STORAGE_KEY) ?
      JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) as string) :
      defaultColumnsShow
    return columnDefs.map(col => ({
      ...col,
      hide: !saved.includes((col as any).colId),
    }))
  }, [columnDefs])

  const columnDefsAutoWithVisibility = useMemo(() => {
    const saved: string[] = localStorage.getItem(LOCAL_STORAGE_KEY_AUTO) ?
      JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY_AUTO) as string) :
      defaultColumnsShowAuto
    return columnDefsAuto.map(col => ({
      ...col,
      hide: !saved.includes((col as any).colId),
    }))
  }, [columnDefsAuto])




  // ── Column show/hide — Tab TỰ ĐỘNG ──────────────────────────────────────


  // ─────────────────────────────────────────────────────────────────────────


  const gListCampaignManual = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    setLoadingTable(true)
    const result = await campaignApi.getListCampaign(pageSize, pageCurent, dataFilter, 0, searchKeyword)
    if (result?.status) {

      setListCampaignManual(convertData(result.data, pageSize, pageCurent))
      setPagination({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const gListCampaignAuto = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    setLoadingTable(true)
    const result = await campaignApi.getListCampaign(pageSize, pageCurent, dataFilter, 1, searchKeyword)
    if (result?.status) {

      setListCampaignAuto(convertData(result.data, pageSize, pageCurent))
      setPaginationAuto({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    setLoadingTable(false)
  }, 1000)

  const convertData = (data: campaignApi.ICampaign[], pageSize: number, pageCurent: number) => {
    // var stt = (pageCurent - 1) * pageSize + 1;
    const convertData = data.map((item) => {
      const parts = item.numberSend ? item.numberSend.split('/') : ['0', '0'];
      const daGuiVal = Number(parts[0]) || 0;
      const totalVal = parts[1] ? `/${parts[1]}` : '/0';
      return {
        key: item.id,
        id: item.id,
        role: item.role,
        muc_tieu: item.targetTitle,
        ma_chien_dich: item.code || '',
        ten_chien_dich: item.title,
        trang_thai: item.status,
        view: item.view,
        kenh_gui: item?.network?.map(item1 => ({
          text: item1.title,
          img: URL_CHANNEL + item1.image
        })),
        da_gui: daGuiVal,
        total: totalVal,
        nhom_khach_hang_nhan: formatPrice(parts[1]),
        khach_hang_nhan: formatPrice(parts[1]),
        thoi_gian_gui: item.dateSend ? `${item.dateSend} ${item.timeSend || ''}`.trim() : (item.timeSend || ''),
        da_chi_tieu: item.totalDeposit,
        nguoi_tao: item.admin || '',
        ngay_tao: item.creationDate || '',
      }
    })
    return convertData
  }

  const glistCampaignManualByExcel = useThrottle(async () => {
    const result = await await campaignApi.getListCampaign(
      LIMIT_EXPORT_EXCEL, 1, dataFilter, 0, searchKeyword
    )
    if (result?.status) {
      formattedDataExcel(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }, 2000)

  const formattedDataExcel = (data: campaignApi.ICampaign[]) => {
    const formattedData = data.map((item) => {
      return {
        "Mục tiêu": item.targetTitle,
        "Mã chiến dịch": item.code || '',
        "Tên chiến dịch": item.title,
        "Kênh gửi": item?.network?.map((item1) => item1?.title),
        "Đã gửi": item.numberSend,
        "Thời gian gửi": item.dateSend ? `${item.dateSend} ${item.timeSend || ''}`.trim() : (item.timeSend || ''),
        "Đã chi tiêu": formatPrice(item.totalDeposit) + "đ",
        "Trạng thái": StatusSendCampaign[item.status]?.label || '',
        "Người tạo": item.admin || '',
        "Ngày tạo": item.creationDate || '',
        "Hoạt động": item.view ? "Đang hoạt động" : "Không hoạt động"
      }
    }
    );
    exportExcel(formattedData)
  }

  function exportExcel(convertData: any): boolean {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Danh sách');

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
        const link: HTMLAnchorElement = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${"Danh sách chiến dịch"}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error('Error exporting Excel:', error);
      return false; // Export failed
    }
  }

  const handleCloseSetting = (value: string[], isChange: boolean, reorderedColumns: ColDef[]) => {
    if (isChange) {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(value))
      const updated = reorderedColumns.map(col => ({
        ...col,
        hide: !value.includes((col as any).colId),
      }))
      setColumnDefs(updated)
    }
    setIsOpenAddvance(false)
  }

  const handleCloseSettingAuto = (value: string[], isChange: boolean, reorderedColumns: ColDef[]) => {
    if (isChange) {
      localStorage.setItem(LOCAL_STORAGE_KEY_AUTO, JSON.stringify(value))
      const updated = reorderedColumns.map(col => ({
        ...col,
        hide: !value.includes((col as any).colId),
      }))
      setColumnDefsAuto(updated)
    }
    setIsOpenAddvance(false)
  }

  // TAB

  const onTabChange = (key: string) => {
    setSelectedTab(key);
    sessionStorage.setItem(SESSION_TAB_KEY, key);
  };

  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      pushToast(message, "success")
      // setManualCampPopupShow(false)
      gListCampaignManual(pagination.current, pagination.pageSize)
    }
    else {
      pushToast(message, "warning")
    }
  }

  const openModalDelete = (id: number) => {
    setId(id)
    setIsModalDelete(true)
  }

  const closeModalDelete = () => {
    setId(undefined)
    setIsModalDelete(false)
  }


  const onConfirmDelete = async () => {
    if (!id) return
    const result = await campaignApi.deleteCampaign(id)
    if (result?.status) {
      pushToast(result.message, "success")
      closeModalDelete()
      if (selectedTab === ETypeSendCampaign.MANUALCAMPAIGN) {
        gListCampaignManual(pagination.current, pagination.pageSize)
      } else {
        gListCampaignAuto(paginationAuto.current, paginationAuto.pageSize)
      }
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    if (selectedTab === ETypeSendCampaign.MANUALCAMPAIGN) {
      gListCampaignManual(pageNumber, pageSize)
    } else {
      gListCampaignAuto(pageNumber, pageSize)
    }
  }


  useEffect(() => {
    gListCampaignManual()
    gListCampaignAuto()
  }, [dataFilter, searchKeyword])

  return (
    <Layout
      contentClassName="campaign-sends-notification-content"
    >
      {/* modal add cũ */}
      {/* <ManualCampaignPopup
        isShow={true}
        onSubmitFormModalAdd={onSubmitFormModalAdd}
        setModal={setManualCampPopupShow}
      /> */}

      <AutomatedCampaignPopup
        isShow={autoCampPopupShow}
        onPopupClose={() => setAutoCampPopupShow(false)}
      />
      <AutomatedCampaignDetailPopup
        isShow={autoCampDetailPopupShow}
        onPopupClose={() => setAutoCampDetailPopupShow(false)}
      />

      <ModalDeleteManager
        isOpen={isModalDelete}
        title="Bạn có chắc chắn xóa chiến dịch này"
        titleDelete="Xóa chiến dịch"
        content="Chiến dịch và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
        closeModal={closeModalDelete}
        onConfirm={onConfirmDelete}
      />

      <ModalTarget
        isOpen={isModalTarget}
        closeModal={() => setIsModalTarget(false)}
      />


      <DrawerAddvance
        isOpen={isOpenAddvance}
        columns={baseColumnDefs}
        defaultColumnsShow={selectedTab === ETypeSendCampaign.MANUALCAMPAIGN ? defaultColumnsShow : defaultColumnsShowAuto}
        localStorageValue={selectedTab === ETypeSendCampaign.MANUALCAMPAIGN ? LOCAL_STORAGE_KEY : LOCAL_STORAGE_KEY_AUTO}
        onClose={(value, isChange, reorderedColumns) =>
          selectedTab === ETypeSendCampaign.MANUALCAMPAIGN ?
            handleCloseSetting(value, isChange, reorderedColumns) :
            handleCloseSettingAuto(value, isChange, reorderedColumns)
        }
        closeDrawer={() => setIsOpenAddvance(false)}
      />

      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: 'Marketing', },
          { title: 'Gửi thông báo', },
        ]}
        title='Chiến dịch'
        description='Quản lý chiến dịch gửi thông tin (Notification/SMS/Zalo ZNS/Email)'
      />

      <Tabs
        activeKey={selectedTab}
        items={tabItems}
        className='rs-tabs'
        onChange={onTabChange}
      />
      <div className="">
        {
          selectedTab === ETypeSendCampaign.MANUALCAMPAIGN
          &&
          <>
            <div
              className="custom-page-css w-full flex items-center justify-between pb-2"
            >
              <span className="fsz-16 font-medium lh-24">Danh sách chiến dịch thủ công</span>

              <div className="custom-page-css flex items-center justify-end gap-2">

                <Input
                  placeholder="Tìm kiếm theo mã, tên chiến dịch"
                  className='custom-input-css custom-page-css border'
                  suffix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                  allowClear
                  style={{ width: 300 }}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                  value={searchKeyword}
                />

                <Select
                  placeholder="Kênh gửi"
                  className=" custom-page-css border rounded overflow-hidden w-100-px"

                  allowClear
                  onClear={() => setDataFilter(undefined)}
                  virtual={false}
                  options={DataChannel}
                  onChange={(e) => setDataFilter(e)}
                />
                <Button
                  icon={<DownloadOutlined />}
                  onClick={glistCampaignManualByExcel}

                  className={`${getPermissionClass(download)} `}
                >
                  Xuất DS
                </Button>
                <Button className=" custom-page-css border rounded px-2"
                  onClick={() => setIsModalTarget(true)}
                >
                  <span>Quản lý mục tiêu</span>
                </Button>
                <Button
                  className={`${getPermissionClass(add)} `}
                  type="primary"
                  // className="rs-button"
                  onClick={() =>
                    navigate('/marketing/campaign-sends-notifications/add',
                      {
                        state:
                          { isAutoCampaign: false }
                      })
                  }
                >
                  <PlusCircleOutlined />
                  <span>Chiến dịch mới</span>
                </Button>
                <Button
                  // className="rs-button"
                  icon={<SettingOutlined />}
                  onClick={() => setIsOpenAddvance(true)}
                />
                {/* <div className="ctrl-select-kenh">
                  <Button
                    // className="rs-button"
                    icon={<SettingOutlined />}
                  />
                  <div className="ctrl-pa">
                    <div className="list-kenh">
                      <div className="icon-top-right">
                        <svg width="1em" height="1em" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 6L6 0L0 6H12Z" fill="white" />
                        </svg>
                      </div>

                      <div className="btn-input">
                        <div className="icon-svg">
                          <img src="/customer/cm.svg" alt="" />
                        </div>
                        <div className="text">Gửi SMS</div>
                      </div>

                      <div className="btn-input">
                        <div className="icon-svg">
                          <img src="/customer/email.svg" alt="" />
                        </div>
                        <div className="text">Gửi Email</div>
                      </div>

                      <div className="btn-input">
                        <div className="icon-svg">
                          <img src="/customer/zalo.svg" alt="" />
                        </div>
                        <div className="text">Gửi ZNS</div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>

            <ManualCampaignTable
              loading={loadingTable}
              pagination={pagination}
              tableData={listCampaignManual}
              columnDefs={columnDefsWithVisibility}
              gListCampaignManual={gListCampaignManual}
              openModalDelete={openModalDelete}
              onPaginationChange={onPaginationChange}
            />
          </>
        }
        {
          selectedTab === ETypeSendCampaign.AUTOMATEDCAMPAIGN
          &&
          <>
            <div
              className="custom-page-css w-full flex items-center justify-between pb-2"
            >
              <span className="fsz-16 font-medium lh-24">Danh sách chiến dịch tự động</span>

              <div className="custom-page-css flex items-center justify-end gap-2">

                <Input
                  placeholder="Tìm kiếm theo mã, tên chiến dịch"
                  className='custom-input-css custom-page-css border'
                  suffix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                  allowClear
                  style={{ width: 300 }}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                  value={searchKeyword}
                />

                <Select
                  placeholder="Kênh gửi"
                  className=" custom-page-css border rounded overflow-hidden w-100-px"

                  allowClear
                  onClear={() => setDataFilter(undefined)}
                  virtual={false}
                  options={DataChannel}
                  onChange={(e) => setDataFilter(e)}
                />
                <Button

                  className={`${getPermissionClass(download)} `}
                  icon={<DownloadOutlined />}
                // onClick={glistCampaignManualByExcel}
                >
                  Xuất DS
                </Button>
                <Button className=" custom-page-css border rounded px-2"
                  onClick={() => setIsModalTarget(true)}
                >
                  <span>Quản lý mục tiêu</span>
                </Button>
                <Button

                  className={`${getPermissionClass(add)} `}
                  type="primary"
                  // className="rs-button"
                  onClick={() =>
                    navigate('/marketing/campaign-sends-notifications/add',
                      {
                        state:
                          { isAutoCampaign: true }
                      })
                  }
                >
                  <PlusCircleOutlined />
                  <span>Chiến dịch mới</span>
                </Button>
                <Button
                  icon={<SettingOutlined />}
                  onClick={() => setIsOpenAddvance(true)}
                />
              </div>
            </div>

            <AutomatedCampaignTable
              loading={loadingTable}
              tableData={listCampaignAuto}
              isLoading={false}
              pagination={paginationAuto}
              columnDefs={columnDefsAutoWithVisibility}
              gListCampaignAuto={gListCampaignAuto}
              onShowDetail={() => setAutoCampDetailPopupShow(true)}
              openModalDelete={openModalDelete}
              onPaginationChange={onPaginationChange}
            />
          </>
        }
      </div>


    </Layout>
  );
}

export default CampaignSendsNotifications;
